import React, { useEffect, useState } from 'react'
import IconLink from '../components/IconLink'
import * as Icon from 'react-feather'
import DashboardLayout from '../layouts/DashboardLayout'
import CardLogo from '../components/CardLogo'
import GeozoneLogo from '../assets/svg/logo-geozone.svg'
import GeolocatorLogo from '../assets/svg/geolocator.svg'
import GeocommentLogo from '../assets/svg/geocomment.svg'
import ArcGISurbanLaunchKitLogo from '../assets/arcgis-urban-launch-kit.png'
import ArcGISHubLogo from '../assets/arcgis-hub.png'
import ArcGISDataHealthChecksLogo from '../assets/arcgis-data-health-checks.png'
import ArcGISBusinessAnalystLogo from '../assets/arcgis-business-analyst.png'
import GISLaunchKit3dLogo from '../assets/svg/3d-gis-launch-kit.svg'
import ArcGISLaunchKitLogo from '../assets/arcgis-online-launch-kit.png'
import ArcGISEnterpriseLaunchKitLogo from '../assets/arcgis-enterprice-launch-kit.png'
import ArcGISEnterpriceCloudLaunchKitLogo from '../assets/arcgis-enterprice-cloud-launch-kit.png'
import FieldOperationslaunchKitLogo from '../assets/field-operations-launch-kit.png'
import ArcGISUtilityNetworkLogo from '../assets/arcgis-utility-network.png'
import InviteModal from '../components/Modals/InviteModal'
import MembersModal from '../components/Modals/MembersModal'
import cookie from "../libs/cookie/client";
import SuccessModal from '../components/Modals/SuccessModal'
import { useParams, useHistory } from "react-router-dom";


const MyAccount = props => {

    const { toast } = require('tailwind-toast')
    const history = useHistory();

    const NewJourney = props => {
        let dataLength = cookie.getItem('datatablength')
        if (dataLength < 5) {
            history.push('/area-of-interest/')

        } else {
            toast().success('', 'You already taken Maximum Journey').with({
                shape: 'square',
                duration: 2000,
                speed: 200,
                positionX: 'center',
                positionY: 'top',
                color: 'text-white bg-primary border-primary-dark border rounded-lg',
                fontColor: 'white',
                fontTone: 0
            }).show()
        }
    }


    return (
        <DashboardLayout hideSidebar={true}>
            <h2 className="text-xle font-semibold">Your profile</h2>
           
            <div className="flex mt-6">
                <IconLink
                    to="/change-password/"
                    text="Change Password"
                    icon={<Icon.Eye size={34} strokeWidth={1} />}
                />
            </div>
            <div className="mt-12">
                <h3 className="text-sm mb-2">Journey</h3>
                <div className="flex">
                    <div className="iconsize mx-4">
                    <IconLink
                        to={"/dashboard/" + cookie.getItem('needsassesmentid')}
                        text="My Dashboard"
                        icon={<Icon.Chrome size={34} strokeWidth={1} />}
                    />
                    </div>
                    <div className="iconsize mx-4" onClick={() => NewJourney()}>
                    <IconLink
                        text="Take again journey"
                        icon={<Icon.PlusCircle size={34} strokeWidth={1} replace/>}
                    />
                    </div>
                    <div className="iconsize mx-4">
                    <IconLink 
                        to="/my-account/"
                        text="Your Team"
                        icon={<Icon.Users size={34} strokeWidth={1} />}
                    />
                    </div>
                </div>
            </div>
            <div className="mt-20">
                <h3 className="text-sm mb-2">My Products &amp; Services</h3>
                <div className="flex flex-wrap">
                    <CardLogo logo={GeozoneLogo} />
                    <CardLogo logo={GeolocatorLogo} />
                    <CardLogo logo={GeocommentLogo} />
                    <CardLogo logo={ArcGISurbanLaunchKitLogo} />
                    <CardLogo logo={ArcGISHubLogo} />
                    <CardLogo logo={ArcGISDataHealthChecksLogo} />
                    <CardLogo logo={ArcGISBusinessAnalystLogo} />
                    <CardLogo logo={GISLaunchKit3dLogo} />
                    <CardLogo logo={ArcGISLaunchKitLogo} />
                    <CardLogo logo={ArcGISEnterpriseLaunchKitLogo} />
                    <CardLogo logo={ArcGISEnterpriceCloudLaunchKitLogo} />
                    <CardLogo logo={FieldOperationslaunchKitLogo} />
                    <CardLogo logo={ArcGISUtilityNetworkLogo} />
                </div>
            </div>
            <MembersModal isVisible={true} />
            <InviteModal isVisible={false} />
            <SuccessModal isVisible={false} />

        </DashboardLayout>

    )
}

export default MyAccount
